const getExtensionFromUrl = (url: string): string | undefined => url.match(FILE_EXTENSION_REGEX)?.[1];

const FILE_EXTENSION_REGEX = /\.([a-zA-Z0-9]+)$/;

export default getExtensionFromUrl;
